module.exports = __webpack_public_path__ + "img/racecourse-turffontein-turf-standside-1950.42d07db5.svg";